var React = require('react');

function ForkKnife (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#d12432;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("polygon",{"className":"cls-1","points":"85.92 16.79 58.87 0 23.14 5.08 0 20.14 6.21 20.13 32.49 20.06 39.89 15.29 58.14 3.53 76.6 15.51 76.6 47.62 66.5 48.8 66.5 22.59 52.86 23.06 52.86 50.39 39.33 51.97 39.33 25.61 8.31 24.81 8.31 49.42 39.33 54.96 79.59 50.11 79.59 17.45 85.92 21.56 85.92 16.79"})))]);
}

ForkKnife.defaultProps = {"viewBox":"0 0 85.92 54.96"};

module.exports = ForkKnife;

ForkKnife.default = ForkKnife;
